import styled from "@emotion/styled";
import { OLD_BLUE } from "src/constants/colors";
import { GhostButton } from "src/components/Buttons";
import { HalfCircleAroowIcon } from "src/assets/icons";
import SidebarMenu from "./SidebarMenu";
import { useAuth } from "src/context";

const SignOutWrapper = styled.div`
  position: absolute;
  bottom: 24px;
  left: 80px;

  & > button {
    color: ${OLD_BLUE} !important;
    padding-left: 0;
  }
`;
const Container = styled.div`
  width: 100%;
  padding-left: 80px;
`;

export default ({ currentSection }: { currentSection: string }) => {
  const authObject = useAuth();
  return (
    <Container>
      <SidebarMenu currentSection={currentSection} />
      <SignOutWrapper>
        <GhostButton
          onClick={() => {
            void authObject.logout();
          }}
        >
          <HalfCircleAroowIcon />
          Sign out
        </GhostButton>
      </SignOutWrapper>
    </Container>
  );
};
